const buildMetadata = {
  appId: 'sdk-playground',
  build: 'nile',
  version: '1.0.0',
  platformName: 'browser',
  dev: true,
}

export default buildMetadata
